// API CALLS
export const BEGIN_API_CALL = 'BEGIN_API_CALL'
export const API_CALL_ERROR = 'API_CALL_ERROR'

// SIGN UP
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'

// SIGN IN
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const SIGNIN_ERROR = 'SIGNIN_ERROR'
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED'

// SIGN OUT
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const SIGNOUT_ERROR = 'SIGNOUT_ERROR'

// RESET PASSWORD
export const RESET_SUCCESS = 'RESET_SUCCESS'
export const RESET_ERROR = 'RESET_ERROR'

// ADD PLANT
export const ADD_PLANT_SUCCESS = 'ADD_PLANT_SUCCESS'
export const ADD_PLANT_ERROR = 'ADD_PLANT_ERROR'

// GET PLANT
export const FETCH_PLANT_SUCCESS = 'FETCH_PLANT_SUCCESS'
export const FETCH_PLANT_ERROR = 'FETCH_PLANT_ERROR'

// REMOVE PLANT
export const REMOVE_PLANT_SUCCESS = 'REMOVE_PLANT_SUCCESS'
export const REMOVE_PLANT_ERROR = 'REMOVE_PLANT_ERROR'

// GET PLANTS
export const FETCH_PLANTS_SUCCESS = 'FETCH_PLANTS_SUCCESS'
export const FETCH_PLANTS_ERROR = 'FETCH_PLANTS_ERROR'

// UPDATE PLANT
export const UPDATE_PLANT_SUCCESS = 'UPDATE_PLANT_SUCCESS'
export const UPDATE_PLANT_ERROR = 'UPDATE_PLANT_ERROR'

// RESET PLANTS DATA
export const RESET_PLANTS_SUCCESS = 'RESET_PLANTS_SUCCESS'

// GET WEATHER DATA
export const WEATHER_SUCCESS = 'WEATHER_SUCCESS'
